<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Charity Details</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <button type="submit" class="btn btn-warning btn-fill" @click="editCharity">Edit Charity</button>
                </div>
            </div>
            <div class="table-responsive" v-if="charity">
                <table class="table table-bordered table-light">
                    <tr>
                        <th>Id</th>
                        <td>{{charity.givingId}}</td>
                    </tr>
                    <tr>
                        <th>Charity Name</th>
                        <td>{{charity.givingName}}</td>
                    </tr>
                    <tr>
                        <th>Website</th>
                        <td><a :href="charity.website" target="_blank">{{charity.website}}</a> </td>
                    </tr>
                  <tr>
                    <th>Image</th>
                    <td ><img class="table-thumbnail" :title="charity.imageUrl":src="charity.imageUrl" /></td>
                  </tr>
                  <tr>
                    <th>Image URL</th>
                    <td ><a :href="charity.imageUrl" target="_blank">{{charity.imageUrl}}</a> </td>
                  </tr>
                    <tr>
                        <th>Status</th>
                        <td v-if="charity.active == '0'">Inactive</td>
                        <td v-else>Active</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    import { mapGetters } from 'vuex'
    export default {
        name: 'ViewCharity',
        components: {
            LTable,
        },
        created (){
            console.log('inside view charity')
        this.$store.dispatch('GETSELECTEDCHARITY', this.$route.params.id).then(() =>{
            console.log('selected', this.selectedCharity)
            this.charity = this.selectedCharity;
        })
    },
    data () {
        return {
          charity: {}
        }
    },
    methods: {
        editCharity(){
            this.$router.push({ name: 'EditCharity', params: { id: this.charity.givingId}})
        },
    },
    computed: {...mapGetters([
        'selectedCharity'])
    }
    }
</script>

<style>
    th{
        width: 180px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Charities/CharityDetails.vue